import React from 'react';
import TextField from 'material-ui/TextField';


export default class QueueDialogItemView extends React.Component {

    onQueueTemplateChange(template) {
        this.props.onQueueTemplateChange({
            type: 'MUSTACHE',
            template: template
        });
    }

    render() {
        let template = (this.props.itemListViewTemplate && this.props.itemListViewTemplate.template) || '';
        return (
            <form>
                <TextField
                    className="custom-field custom-multiline-field item-list-view-template-text-field"
                    fullWidth={true}
                    floatingLabelText="Queue List Item Mustache Template"
                    floatingLabelFixed={true}
                    value={template}
                    inputStyle={{fontFamily: 'monospace'}}
                    hintStyle={{whiteSpace: 'pre', fontFamily: 'monospace'}}
                    hintText={'<div>id: {{id}}</div>\n<ul>{{#tags}}<li>{{.}}</li>{{/tags}}</ul>'}
                    multiLine={true}
                    rows={3}
                    rowsMax={6}
                    onChange={(event) => this.onQueueTemplateChange(event.target.value)}/>
                <div className="help-link">for more info visit <a href="https://mustache.github.io/" target="_blank">mustache.github.io</a></div>
                {/*
                 <TextField className="text-field"
                 floatingLabelText="Item View Mustache Template"
                 floatingLabelFixed={true}
                 inputStyle={{fontFamily: 'monospace'}}
                 hintStyle={{bottom: 0, top: 36, whiteSpace: 'pre', fontFamily: 'monospace'}}
                 hintText={'<div>id: {{id}}</div>\n<div>clientId: {{clientId}}</div>\n<div>state: {{#states}}{{name}} {{/states}}</div>'}
                 multiLine={true}
                 rows={3}
                 rowsMax={6}
                 />
                 */}
            </form>
        );
    }

}



// WEBPACK FOOTER //
// ./src/components/queue/QueueDialogItemView.js